<template>
	<div class="content flex flex-align-start">
		<div class="flex-1 mr40">
			<div class="flex flex-align-center">
				<div>当前省份：</div>
				<el-select class="ml5" v-model="province" filterable placeholder="请选择" :disabled="!userInfo.vip" :loading="!isReady" @change="chooseProvince">
				    <el-option v-for="(item,index) in provinceList" :key="index" :label="item" :value="item"></el-option>
				</el-select>
			</div>
			
			<el-tabs v-model="TabCur" class="mt20" @tab-click="province && chooseProvince(province)">
				<el-tab-pane :label="item" v-for="(item,index) in tabs" :key="index">
					<div style="min-height: 300px;padding: 15px 0 50px;" v-loading="isLoading">
						<div style="color: #cccccc;" v-if="!province">请先选择省份</div>
						<div class="" v-else>
							<div class="rich-text" v-html="richText[Number(index)]"></div>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
		
		<!-- 宣传图 -->
		<el-carousel class="border-radius-10" style="width: 360px;" trigger="click" :interval="5000" arrow="never" height="480px">
			<el-carousel-item v-for="(item,index) in swiper" :key="index">
				<el-image style="width: 360px;height: 480px;" :src="item.image" fit="cover"></el-image>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
import { EventBus } from '@/main.js'
export default {
	name: 'Ordinary',
	data(){
		return{
			provinceList: [],
			province: '',
			
			tabs: ['查看报考条件', '名单公示'],
			TabCur: '0',
			
			richText: ['', '']
		}
	},
	mounted(){
		EventBus.$emit('router-path', this.$route.path)
		
		if(this.token) this.getUser()
		
		this.getProvince()
	},
	methods: {
		async getProvince(){
			this.$http.get('/api/webs/search/ptxdsProvince')
			    .then(response => {
			        let res = response.data
					
					this.isReady = true
					this.provinceList = res.list
			    })
			    .catch(error => {
			        console.error(error)
			    })
		},
		
		async chooseProvince(e){
			this.province = e
			this.isLoading = true
			
			this.$http.get('/api/webs/search/ptxdsOther', { params: { province: e } })
			    .then(response => {
			        let res = response.data
					
					this.isLoading = false
					this.richText[0] = res.ptCkbktj
					this.richText[1] = res.ptLymdgs
			    })
			    .catch(error => {
			        console.error(error)
					this.isLoading = false
			    })
		}
	}
}
</script>

<style>
.el-input--suffix{
	width: 160px !important;
}
</style>